/* На каждый шаблон свой JS модуль */
import { PHP } from '../PHP';
import { joint } from '../joint';

window.unit.art = {
	init() {
		const albom = document.querySelector(".albom");
		//var obLst = new ObjList(albom);
		if(PHP.debug >0) console.log('init()');

		/*=============================
		 Теперь ../lib/cards' здесь;
		===============================*/
		var reqOffset = PHP.pgMore;
		var reqLimit = reqOffset;
		if (boxCards = document.querySelector('.box')) {
			let showMore = document.querySelector('.showMore');
			if(!showMore) return;
			showMore.addEventListener("click", () => {
				//joint.getData('/?t='+JED.tmpl+'&a=more&id=' + JED.pgId + '&ptr=' + reqOffset + '&ed=' + '1', function (data) {
				joint.getData('/?t=' + JED.tmpl + '&a=more&id=' + JED.pgId + '&ptr=' + reqOffset, function (data) {
					var result = '';
					//console.log('data='+data);
					if (data != 0) {
						data = JSON.parse(data);
						for (id in data) {
							boxCards.insertAdjacentHTML('beforeend', data[id]);
						}
						//Для подгруженных карточек нужно заново активировать менюшки
						if (JED.tune.edit) objMenu.init();
					} else {//Надо скрыть ссылку Показать ещё
						document.querySelector('.showMore').style.color = '#aaa';
					}
					reqOffset += reqLimit;
				})
			}, false);
		}
	}
}